export function safeJsonParse<T>(input: string): T | undefined {
  try {
    if (input.length === 0 || input === 'undefined') return undefined;
    const typeParsed = JSON.parse(input) as T;

    if (typeParsed) {
      return typeParsed;
    } else {
      throw new Error('JSON String is not of Generic<T> type');
    }
  } catch (error) {
    console.warn('Invalid input or parse error:', error);
    return undefined;
  }
}
